<template>
    <form :id="id" @submit.prevent="submitForm" @input="clearError($event.target.name)" :action="action" :method="method">
        <slot :validation="validation" :valid="valid" />
    </form>
</template>
<script>
import { ref } from "vue";

export default {

    name: 'acadia-form',

    props: {
        id: String,
        modelValue: {},
        autoReset: Boolean,
        action: String,
        method: String,
    },

    setup(props, context) {

        const original = JSON.parse(JSON.stringify(props.modelValue))

        const validation = ref({
            errors: {}
        })

        function hasError(field) {
            return validation.value.errors.hasOwnProperty(field);
        }

        function clearError(field) {
            if (field && validation.value.errors) {
                delete validation.value.errors[field];

                return;
            }

            validation.value.errors = {};
        }

        function getError(field) {
            if (validation.value.errors && validation.value.errors[field]) {
                return validation.value.errors[field][0];
            }
        }

        function valid() {
            return !Object.keys(validation.value.errors).length;
        }

        function post(url) {
            return submit('post', route(url));
        }

        function put(url, definition) {
            return submit('put', route(url, definition));
        }

        function patch(url, definition) {
            return submit('patch', route(url, definition));
        }

        function submit(requestType, url) {
            return new Promise((resolve, reject) => {

                axios[requestType](url, props.modelValue)
                    .then(response => {

                        context.emit('update:modelValue', Object.keys(props.modelValue)
                            .reduce((obj, key) => ({ ...obj, [key]: original[key] }), {}))

                        clearError()

                        resolve(response.data);
                    })
                    .catch(error => {
                        validation.value = error.response.data

                        reject(error.response.data);
                    });
            });
        }

        const form = ref({
            post,
            put,
            patch,
        })

        function submitForm() {
            context.emit('onSubmit', form.value)
        }

        return {
            submitForm,
            hasError,
            getError,
            clearError,
            valid,
            validation
        }
    }
}

</script>
